import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/banner-ads/banner-ads-small.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/banner-ads/banner-ads.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/banner-ads/banner-vips.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/button-common/button-common.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/movie-ranked/movie-ranked.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pagination-common/pagination-common.tsx");
